<div class="copy-config-from-list-wrapper">


  <div class="title_close">
    <h3 class="copy-config-from-title">{{ 'sources.configuration.copyConfigFrom' | translate | uppercase }}</h3>

    <i class="material-icons close-icon" (click)="onCloseModal()">
      close
    </i>
  </div>

  <mat-tab-group [selectedIndex]="selectedTab" class="templates-ds-group">
    <mat-tab label="{{ 'sources.configuration.templatesTabTitle' | translate }}" class="templates-tab">
      <mee-copy-from-templates
        [isCopyDSConfig]="isCopyDSConfig"
        [dialogData]="dialogData"
        (onChooseSourceCopyItem)="onChooseDSForCopy($event)"
        (selectedTabChanged)="selectedTabChanged($event)"
      ></mee-copy-from-templates>
    </mat-tab>

    <mat-tab label="{{ 'sources.configuration.dataSourcesTabTitle' | translate }}" class="data-sources-tab">
      <mee-copy-from-sources
        [isCopyDSConfig]="isCopyDSConfig"
        [dialogData]="dialogData"
        (onChooseSourceCopyItem)="onChooseDSForCopy($event)"
      ></mee-copy-from-sources>
    </mat-tab>
  </mat-tab-group>


</div>
